export { StyledBar } from "./StyledBar";
